<form [formGroup]="formGroup">
  <!--Personal name-->
  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label for="first_name" class="label">{{ 'sign_up.account_form.first_name' | translate }}*</label>
    <input type="text" class="form-control" id="first_name" required formControlName="first_name" />
    <div *ngIf="showErrors && formGroup.controls.first_name.errors" class="warning">
      <span *ngIf="formGroup.controls['first_name'].errors?.required">{{
        'sign_up.account_form.first_name_error' | translate
      }}</span>
    </div>
  </div>

  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label for="last_name" class="label">{{ 'sign_up.account_form.last_name' | translate }}*</label>
    <input type="text" class="form-control" id="last_name" required formControlName="last_name" />
    <span class="warning" *ngIf="showErrors && formGroup.controls['last_name'].errors?.required">{{
      'sign_up.account_form.last_name_error' | translate
    }}</span>
  </div>

  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label for="role_type_key" class="label pb-0">{{ 'sign_up.account_form.role' | translate }}</label>
    <div class="select-wrapper mt-2">
      <select class="form-control" id="role_type_key" required formControlName="role_type_key">
        <option *ngFor="let role of roleTypeKeyList" value="{{ role }}">
          {{ 'interface_mode_key.' + role | translate }}
        </option>
      </select>
    </div>

    <span class="warning" *ngIf="showErrors && formGroup.controls['role_type_key'].errors?.required">{{
      'sign_up.account_form.role_error' | translate
    }}</span>
    <div class="text-muted mt-2">
      {{ 'sign_up.account_form.role_help' | translate }}
    </div>
  </div>

  <div class="form-group my-3 form-success-highlight" [class.form-error-highlight]="showErrors">
    <label class="label" for="marketing_agreed">{{ 'sign_up.account_form.newsletter' | translate }}</label
    ><br />
    <input type="checkbox" formControlName="marketing_agreed" class="me-2" id="marketing_agreed" />
    <label for="marketing_agreed">{{ 'sign_up.account_form.newsletter_want_to_be_notified' | translate }}</label>
    <div class="text-muted mt-1">
      {{ 'sign_up.account_form.newsletter_help' | translate }}
    </div>
  </div>
  <nk-password-strength
    *ngIf="formGroup"
    [passwordFormGroup]="formGroup"
    [showErrors]="showErrors"></nk-password-strength>
</form>
